"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICONS_SYSTEM = [
    'SvgAccount',
    'SvgAddCircle',
    'SvgAddSquare',
    'SvgAlert',
    'SvgArrowUp',
    'SvgArrowRight',
    'SvgArrowDown',
    'SvgArrowLeft',
    'SvgBadge',
    'SvgBookmark',
    'SvgBuilding',
    'SvgBusiness',
    'SvgCalendar',
    'SvgCamera',
    'SvgCart',
    'SvgCategory',
    'SvgChallenge',
    'SvgChefHat',
    'SvgCloseCircle',
    'SvgCoupon',
    'SvgCreditCard',
    'SvgDelete',
    'SvgDeliveryBike',
    'SvgDeliveryVan',
    'SvgDineIn',
    'SvgDislike',
    'SvgDonate',
    'SvgEdit',
    'SvgFavourite',
    'SvgFilter',
    'SvgFlash',
    'SvgGift',
    'SvgGlutenFree',
    'SvgHalal',
    'SvgHealthierChoice',
    'SvgHelp',
    'SvgHide',
    'SvgHome',
    'SvgInfo',
    'SvgLike',
    'SvgLinkOut',
    'SvgList',
    'SvgLocation',
    'SvgLocationPin',
    'SvgLogin',
    'SvgLogout',
    'SvgIdentity',
    'SvgMenuHamb',
    'SvgMinusCircle',
    'SvgNoInternet',
    'SvgNotification',
    'SvgOrders',
    'SvgPot',
    'SvgPromotion',
    'SvgQrCode',
    'SvgScales',
    'SvgScan',
    'SvgSearch',
    'SvgSettings',
    'SvgShare',
    'SvgShow',
    'SvgStar',
    'SvgStore',
    'SvgSuccess',
    'SvgTakeaway',
    'SvgClock',
    'SvgTips',
    'SvgTransFatFree',
    'SvgTrophy',
    'SvgUser',
    'SvgVegetarian',
    'SvgWhisk',
    'SvgWine'
];
exports.ICONS_SYSTEM_NO_FILLED = [
    'SvgArrowDoubleUp',
    'SvgArrowDoubleRight',
    'SvgArrowDoubleDown',
    'SvgArrowDoubleLeft',
    'SvgAdd',
    'SvgMinus',
    'SvgClose',
    'SvgTick',
    'SvgMenuMoreHorizontal',
    'SvgMenuMoreVertical',
    'SvgHistory',
    'SvgLoading',
    'SvgLinkPlus',
    'SvgLinkPoints',
    'SvgArrowUpward',
    'SvgTrendingUp',
    'SvgDirectionalArrowLeft',
    'SvgDirectionalArrowRight',
    'SvgOrderNote'
];
exports.ICONS_SOCIAL_MEDIA = [
    'SvgFacebook',
    'SvgInstagram',
    'SvgApple',
    'SvgGoogle',
    'SvgSpotify',
    'SvgYoutube'
];
exports.ICONS_ALL = __spreadArrays(exports.ICONS_SYSTEM, exports.ICONS_SYSTEM_NO_FILLED, exports.ICONS_SOCIAL_MEDIA);
exports.ICONS_DECOMMISSION = ['SvgBack', 'SvgCheck', 'SvgProfile', 'SvgVerified'];
//# sourceMappingURL=icon-group.js.map